<div class="container-fluid">
 <div *ngIf="articleSummaryList.length>0">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;
      Article Exit Summary</h5>
  </div>
  <div id="mainContent" class="container">
    <div class="pt-4 pb-2">
      <table class="table table-sm table-bordered">
        <!-- style="display: block; overflow-x: auto; white-space: nowrap" -->
        <thead class="">
          <tr>
            <th></th>
            <th>Article Name</th>
            <th>Separation Date</th>
            <th>Partner</th>
            <th>Eligible To Rehire</th>
          </tr>
        </thead>
        <tbody *ngFor="let detail of articleSummaryList">
          <td> <a style="color: #17a2b8; cursor: pointer" (click)="viewExitFormDetails(detail)">View Exit Form</a></td>
          <td>{{detail.user.firstName}} {{detail.user.middleName}} {{detail.user.lastName}}</td>
          <td>{{detail.separationDate | date:'dd-MMMM-yyyy'}}</td>
          <td>{{detail.partner.firstName}} {{detail.partner.middleName}} {{detail.partner.lastName}}</td>
          <td *ngIf="detail.eligibleForRehire==true;else elseBlock">Yes</td>
          <ng-template #elseBlock>
            <td>No</td>
          </ng-template>
        </tbody>
      </table>
    </div>
  </div>
</div>


  <div *ngIf="employeeSummaryList.length>0">
    <div class="row pt-4 pl-4" style="font-size: 22px !important;
font-weight: 400;
color: #424242;">
  <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;
    Employee Exit Summary</h5>
</div>
    <div class="container" id="mainContent">
    <div class="pt-4 pb-2">
      <table class="table table-sm table-bordered">
        <thead class="">
          <tr>
            <th></th>
            <th>Employee Name</th>
            <th>Separation Date</th>
            <th>Job Title </th>
            <th>Job Code</th>
            <th>Eligible To Rehire</th>
          </tr>
        </thead>
        <tbody *ngFor="let detail of employeeSummaryList">
          <td><a style="color: #17a2b8; cursor: pointer" (click)="viewExitFormDetails(detail)">View Exit Form</a></td>
          <td>{{detail.user.firstName}} {{detail.user.middleName}} {{detail.user.lastName}}</td>
          <td>{{detail.separationDate | date:'dd-MMMM-yyyy'}}</td>
          <td>{{detail.jobTitle}}</td>
          <td>{{detail.jobCode}}</td>
          <td *ngIf="detail.eligibleForRehire==true;else elseBlock">Yes</td>
          <ng-template #elseBlock>
            <td>No</td>
          </ng-template>
        </tbody>
      </table>
    </div>
  </div>
</div>
</div>